import { type ReactElement } from 'react';
import SolutionPageLayout from '../../components/features/SolutionPageLayout';

export default function Ecommerce(): ReactElement {
  return (
    <SolutionPageLayout
      badge="Für E-Commerce"
      title="Buchhaltung für Online-Händler – automatisiert und skalierbar"
      subtitle="Hunderte Bestellungen pro Tag? Saldify automatisiert Ihre Buchhaltung und wächst mit Ihrem Online-Geschäft."
      heroImage="/screenshots/app-banking.webp"
      heroImageAlt="Zahlungen von Stripe, PayPal und SumUp in Saldify abgleichen"
      introTitle="E-Commerce Buchhaltung auf Autopilot"
      introText="Als Online-Händler haben Sie mit Massen an Transaktionen zu tun. Manuelle Buchhaltung ist da keine Option. Saldify integriert sich nahtlos mit Ihrem Shop und erledigt den Rest."
      introBullets={[
        'Automatische Rechnungserstellung bei Bestellung',
        'Anbindung an Shopify, WooCommerce, Shopware & mehr',
        'Automatische Zuordnung von Zahlungseingängen',
        'OSS-Meldung für EU-weiten Versand',
      ]}
      benefits={[
        {
          title: 'Shop-Integration',
          description: 'Direkte Anbindung an alle gängigen Shopsysteme und Marktplätze.',
        },
        {
          title: 'Automatische Rechnungen',
          description: 'Rechnungen werden automatisch bei jeder Bestellung erstellt.',
        },
        {
          title: 'Payment-Anbindung',
          description: 'Stripe, PayPal, Klarna & Co. werden automatisch abgeglichen.',
        },
        {
          title: 'OSS-Unterstützung',
          description: 'One-Stop-Shop Meldung für EU-weiten Versand an Privatkunden.',
        },
        {
          title: 'Massenverarbeitung',
          description: 'Verarbeiten Sie tausende Transaktionen ohne Performance-Einbußen.',
        },
        {
          title: 'Bestandsführung',
          description: 'Behalten Sie den Überblick über Ihren Warenbestand.',
        },
      ]}
      useCases={[
        {
          title: 'Eigener Online-Shop',
          description: 'Shopify, WooCommerce oder Shopware – vollautomatische Buchhaltung.',
        },
        {
          title: 'Amazon FBA',
          description: 'Amazon-Abrechnungen importieren und automatisch verbuchen.',
        },
        {
          title: 'eBay-Händler',
          description: 'eBay-Verkäufe synchronisieren und Gebühren erfassen.',
        },
        {
          title: 'Multi-Channel',
          description: 'Verkaufen Sie auf mehreren Plattformen – eine Buchhaltung für alles.',
        },
      ]}
      features={[
        'Shop-Integrationen (Shopify, WooCommerce, etc.)',
        'Marktplatz-Anbindung (Amazon, eBay, Etsy)',
        'Payment-Sync (Stripe, PayPal, Klarna)',
        'Automatische Rechnungserstellung',
        'OSS-Meldung für EU-Versand',
        'Warenwirtschaft & Bestandsführung',
        'Retouren-Management',
        'Echtzeit-Auswertungen nach Kanal',
      ]}
      recommendedPlan={{
        name: 'Professional',
        price: '24€/Monat',
        description: 'Ideal für E-Commerce: Unbegrenzte Transaktionen, Shop-Integration und automatische Rechnungen.',
      }}
      testimonial={{
        quote: 'Seitdem Saldify an meinen Shop angebunden ist, muss ich mich um Rechnungen gar nicht mehr kümmern. Läuft alles automatisch.',
        author: 'Markus R.',
        role: 'Geschäftsführer',
        company: 'StyleShop GmbH',
      }}
    />
  );
}
